import { getUsuario } from "@/utils/session";
import { countPendingOutbox } from "@/utils/posOffline/sync";
import { countPendingMesasCobrosPedidos } from "@/utils/posOffline/mesasSync";
import { countPendingCajaOutbox } from "@/utils/posOffline/cajaSync";

/**
 * Ventas POS + cobros/pedidos de mesas + ops de caja pendientes de sincronizar.
 * Usado como badge del icono wifi en el sidebar de escritorio.
 */
export async function countPendingOfflineNotifs(usuario) {
  const u = usuario || getUsuario();
  if (!u) return 0;
  const [sales, mesas, cajas] = await Promise.all([
    countPendingOutbox().catch(() => 0),
    countPendingMesasCobrosPedidos(u).catch(() => 0),
    countPendingCajaOutbox(u).catch(() => 0),
  ]);
  return Number(sales || 0) + Number(mesas || 0) + Number(cajas || 0);
}

export function onPendingOfflineChange(fn) {
  if (typeof window === "undefined") return () => {};
  const handler = () => {
    try {
      fn();
    } catch (_) {
      /* ignore */
    }
  };
  window.addEventListener("pos:outbox-updated", handler);
  window.addEventListener("mesas:outbox-updated", handler);
  window.addEventListener("caja:outbox-updated", handler);
  return () => {
    window.removeEventListener("pos:outbox-updated", handler);
    window.removeEventListener("mesas:outbox-updated", handler);
    window.removeEventListener("caja:outbox-updated", handler);
  };
}
